const dropzoneSettings = {
  url: "https://api.cloudinary.com/v1_1/dzneqacw6/image/upload",
  url_videos: "https://api.cloudinary.com/v1_1/dzneqacw6/video/upload",
  api_key: 943133665768727,
  upload_preset: "yetv2mty",
  videoFileTypes: "video/*",
  photoFileTypes: "image/*",
  thumbnailWidth: 150,
  maxFilesize: 140,
  parallelUploads: 4,

  //headers: { "My-Awesome-Header": "header value" }
  //dictDefaultMessage: "<i class='fa fa-cloud-upload'></i>UPLOAD ME",
  //addRemoveLinks: true,
}
const apiSettings = {
  url: "http://localhost:8080",
  // url: "https://api.yoroky.com",
  app_base: "localhost:5000",
  // app_base: "pug.yoroky.com",
  //=url :  "http://localhost:49002"
}
const directa_prod = {
  /* country: "PE",
  language: "es",
  currency: "PEN", */
  url_logo: "https://69prepagos.com/directa_logo69.png",
  api_key: "oDJHLmwwdFoazavmpxok",
  test: false,
  notifyUrl: `${apiSettings.url}/directa-confirmation/`,
  notifyUrlRecharge: `${apiSettings.url}/directa-confirmation/recharge`,
  redirectUrlBase: `https://panel.${apiSettings.app_base}`,
}
const paymentsMethods = [
  { label: "Efectivo", type: "cash" },
  /* { label: "Directa24", type: "directa24" },*/
  { label: "Bancolombia", type: "bancolombia" },
]

const company_data = {
  client_service: "573024029675",
}

// languaje configs
const CURRENCY = "COP"
const COUNTRY = "CO"
const LANGUAGE = "es"
function getSymbolCurrency() {
  // this implementation wont work on all cases
  if (CURRENCY == "COP") {
    return "$"
  } else if (CURRENCY == "PEN") {
    return "SO"
  } else {
    return "$"
  }
}
function addThousands(value) {
  if (CURRENCY == "COP" && value / 1000 <= 1) {
    value = value * 1000
    value = Number(value).toLocaleString("es-CO", {
      style: "currency",
      currency: "COP",
      minimumFractionDigits: 0,
    })
    return value
  } else {
    return Number(value).toLocaleString(`${LANGUAGE}-${COUNTRY}`, {
      style: "currency",
      currency: CURRENCY,
      minimumFractionDigits: 0,
    })
  }
}
function getValue(value) {
  if (CURRENCY == "COP" && value / 1000 <= 1) {
    return value * 1000
  } else {
    return value
  }
}

export default {
  company_data,
  dropzoneSettings,
  apiSettings,
  paymentsMethods,
  directa_prod,
  CURRENCY,
  COUNTRY,
  addThousands,
  getSymbolCurrency,
  getValue,
}
